import React from 'react';
import QuoteWizard from '../components/QuoteWizard';
import { IconCheck, IconGoogle, IconStar } from '../components/Icons';

export const SKYLINE_IMAGE = '/assets/images/difc-skyline-dusk.webp';

// Figures already published on the site's previous hero and the Corporate Tax page.
const GOOGLE_RATING = '4.9';
const TRADE_LICENCE = '795106';
const YEARS = '25+';
const BUSINESSES = '500+';

const HERO_POINTS = [
  'Fixed monthly fee. No hourly billing, no lock-in.',
  'Works in Zoho Books, QuickBooks, Xero or Tally.',
  'Reply on WhatsApp within 15 minutes, Mon–Fri.',
];

const TRUST_ITEMS = [
  { title: 'Licensed', sub: `UAE tax consultants · Trade Licence ${TRADE_LICENCE}` },
  { title: `${YEARS} years`, sub: 'in UAE tax practice' },
  { title: `${BUSINESSES} businesses`, sub: 'advised across the UAE' },
  { title: 'CA', sub: 'ICAI-member accountants' },
  { title: GOOGLE_RATING, sub: 'verified Google rating', google: true },
];

const Stars = ({ size }) => (
  <span className="bk-rating-stars" aria-hidden="true">
    {[0, 1, 2, 3, 4].map((i) => <IconStar key={i} size={size} />)}
  </span>
);

const HeroSection = () => (
  <section className="bk-hero" data-screen-label="Hero">
    <div className="bk-hero-bg" style={{ backgroundImage: `url(${SKYLINE_IMAGE})` }} aria-hidden="true" />
    <div className="bk-container bk-hero-grid">
      <div className="bk-hero-copy">
        <span className="bk-hero-rating" aria-label={`Rated ${GOOGLE_RATING} out of 5 on Google`}>
          <IconGoogle size={15} />
          <span>{GOOGLE_RATING}</span>
          <Stars size={11} />
          <span>Google rating</span>
        </span>
        <p className="bk-hero-meta-loc">Bookkeeping services in Dubai · Mainland &amp; Free Zone</p>

        <h1 className="bk-hero-title">
          Bookkeeping services in Dubai, closed by the <span className="bk-hero-mark">10th.</span>
        </h1>

        <p className="bk-hero-desc">
          Send receipts on WhatsApp. A named accountant keeps your books, a second one reviews them, and your
          monthly report lands on the 10th. One fixed fee.
        </p>

        <ul className="bk-hero-points">
          {HERO_POINTS.map((point) => (
            <li key={point}>
              <span className="bk-hero-check" aria-hidden="true">
                <IconCheck size={12} />
              </span>
              <span>{point}</span>
            </li>
          ))}
        </ul>
      </div>

      <div id="hero-lead-card" className="bk-hero-card">
        <QuoteWizard formId="heroForm" />
      </div>
    </div>

    <div className="bk-trust-strip">
      <ul className="bk-container bk-trust-row">
        {TRUST_ITEMS.map((item) => (
          <li key={item.sub} className="bk-trust-item">
            <span className="bk-trust-title">
              {item.google && <IconGoogle size={18} />}
              {item.title}
              {item.google && <Stars size={13} />}
            </span>
            <span className="bk-trust-sub">{item.sub}</span>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default HeroSection;
